import { render, staticRenderFns } from "./TermsParagraph.vue?vue&type=template&id=1265e303&scoped=true"
import script from "./TermsParagraph.vue?vue&type=script&lang=ts"
export * from "./TermsParagraph.vue?vue&type=script&lang=ts"
import style0 from "./TermsParagraph.vue?vue&type=style&index=0&id=1265e303&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1265e303",
  null
  
)

export default component.exports